export default "__VITE_ASSET__DOWtHV$E__"